import React, { useEffect } from "react";

const ExpandableDefinition = ({ word, paragraphId, onExpand, onHover }) => {
  const isMobile = window.matchMedia("(hover: none)").matches;

  const handleClick = () => {
    onExpand(word, paragraphId); // ✅ Send both
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".trigger-word")) {
        onExpand(null, null); // ✅ clear both word and paragraph
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [onExpand]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <span
      className="trigger-word"
      tabIndex="0"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onMouseEnter={() => !isMobile && onHover(word, paragraphId)}
      onMouseLeave={() => !isMobile && onHover(null, null)}
    >
      {word}
    </span>
  );
};

export default ExpandableDefinition;
